<template>
  <div v-if="product">
    <div class="space-y-4">
      <product-eyebrow />
      <h1 :class="brandClasses.headingProductName" data-test-id="product-name">
        {{ product.name }}
      </h1>
      <p
        v-if="$feature.showShortDescriptionOnPDP && product.shortDescription"
        class="body-2"
      >
        {{ product.shortDescription }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { brandClasses } = useAppConfig().pages.pdp
const { product } = usePdp()
</script>
